export const RECOMMENDED_JOBS_ROUTE_NAME = 'recommended-jobs';
export const RECOMMENDED_JOBS_ROUTE = '/recommended';

export const SAVED_SEARCH_ROUTE_NAME = 'saved-searches';
export const SAVED_SEARCH_ROUTE = '/my-activity/saved-searches';
